module.exports = __webpack_public_path__ + "img/certTempEn.d1edb59a.png";